import { useEffect, useState } from 'react';
import { mobileEvent } from '../utils/mobile';

export interface AppInfo {
	/**
	 * The name of the app.
	 *
	 * @since 1.0.0
	 */
	name: string;
	/**
	 * The identifier of the app.
	 * On iOS it's the Bundle Identifier.
	 * On Android it's the Application ID
	 *
	 * @since 1.0.0
	 */
	id: string;
	/**
	 * The build version.
	 * On iOS it's the CFBundleVersion.
	 * On Android it's the versionCode.
	 *
	 * @since 1.0.0
	 */
	build: string;
	/**
	 * The app version.
	 * On iOS it's the CFBundleShortVersionString.
	 * On Android it's package's versionName.
	 *
	 * @since 1.0.0
	 */
	version: string;
}

export const useAppInfo = () => {
	const [loading, setLoading] = useState(true);
	const [appInfo, setAppInfo] = useState<AppInfo | undefined>();
	const fetchAppInfo = async () => {
		const info = await mobileEvent({
			type: 'GetAppInfo',
		});
		setAppInfo(info as any);
		setLoading(false);
	};
	useEffect(() => {
		// eslint-disable-next-line no-console
		fetchAppInfo().catch(console.error);
	}, []);

	return { appInfo, loading };
};
